module.exports = __webpack_public_path__ + "img/sku-guide-id.83665f1.jpg";